import React from 'react'
import About from '../pages/About' 
import Contact from '../pages/Contact'

const AboutComponents = () => {
  return (
    <div>
        <About/>
        <Contact/>
      
    </div>
  )
}

export default AboutComponents
